import Vue from 'vue'
import App from './App.vue'
import axios from "axios";

Vue.prototype.$http = axios;

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js